import { render } from "./DomainSmall.vue?vue&type=template&id=3b3e0228&scoped=true"
import script from "./DomainSmall.vue?vue&type=script&lang=js"
export * from "./DomainSmall.vue?vue&type=script&lang=js"

import "./DomainSmall.vue?vue&type=style&index=0&id=3b3e0228&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3e0228"]])

export default __exports__